import React, { useEffect, useState } from "react";
import { getTrancheHistory } from "../../../service/api";
import { formatToYYYYMMDD } from "../../../utils/formatDate";
import { TrancheHistoryTable } from "./TrancheHistory.table";

const dealNameId = "683eeb3d5a489901b765f98d";

const TrancheHistoryModal = ({ trancheId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [allRows, setAllRows] = useState(undefined);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const fetchHistory = async () => {
    try {
      const res = await getTrancheHistory({
        page: currentPage,
        limit: itemsPerPage,
        trancheId,
      });
      const rows = res.data.docs || [];

      setAllRows(rows);
      setTotalDocs(res.data.totalDocs || 0);
    } catch (err) {
      setAllRows([]);
      console.error(err);
    }
  };

  const rows =
    allRows?.map((r) => ({
      user: r?.createdBy?.name,
      statusDate: formatToYYYYMMDD(r.createdAt),
      status: r.status,
      changeType: r.changeType,
      dealName: r?.assetId?.assetData[dealNameId],
      assetId: r?.assetId?._id,
    })) || [];

  useEffect(() => {
    fetchHistory();
  }, [currentPage, itemsPerPage]);

  const isLoading = !allRows;

  return (
    <TrancheHistoryTable
      isLoading={isLoading}
      rows={rows}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      totalDocs={totalDocs}
      itemsPerPage={itemsPerPage}
      setItemsPerPage={setItemsPerPage}
    />
  );
};

export default TrancheHistoryModal;
